<template>
    <div :style="{'max-width': '1024px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        <b-card-text><h3>All Orders</h3></b-card-text>


        <div v-if="date_counts">
            <b-card>
                <b-card-text>
                    <b-form-select 
                        size="sm" 
                        style="max-width: 200px;"
                        v-model="date_type"
                        :options="date_type_options"
                        v-on:change="fetch_counts_by_dates"
                    ></b-form-select>
                </b-card-text>
                <b-button :pressed="date_count.dt == active_date" size="sm" :variant="get_variant(date_count)" style="margin: 5px; color: black;" v-for="date_count, didx in date_counts" v-bind:data="date_count" v-bind:key="didx" @click="fetch_data(date_count)" >
                    {{ date_count.dt }} ({{ date_count.cnt }})
                </b-button>
            </b-card>
        </div>

        <div style="margin-top: 10px;" class="text-monospace">
            <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                <div v-if="items.length > 0" class="text-monospace">

                    <table style="width: 100%;">
                        <thead>
                            <tr style="background: black; color: white;">
                                <td class="ipt_tdhr">
                                    SALE DATE
                                </td>
                                <td class="ipt_tdhr">
                                    INVOICE #
                                </td>
                                <td class="ipt_tdhr">
                                    LOCATION
                                </td>
                                <td class="ipt_tdhr">
                                    ITEMS
                                </td>
                                <td class="ipt_tdhr">
                                    NOTES
                                </td>
                                <td class="ipt_tdhr">
                                    ACTION
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item, idx in items" v-bind:key="idx" >
                                <td class="ipt_tdhr">
                                    {{ item.created_date }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ (item.invoice_id) }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{packet.locationsdict[item.location_id]}}
                                </td>
                                <td class="ipt_tdhr" style="text-align: left;">
                                    <div v-for="element, eidx in item.items" v-bind:key="eidx">
                                        <div style="display: inline-block; padding: 5px; width: 250px;">{{ element.product_sku }} x {{ element.quantity }}</div> | 
                                        <div style="display: inline-block; padding: 5px; width: 100px;">{{ element.order_type }}</div> 
                                        <div style="display: inline-block; padding: 5px; width: 100px;">{{ item.request_date }}</div>
                                    </div>
                                </td>
                                <td class="ipt_tdhr">
                                    {{ item.comments }}
                                </td>
                                <td class="ipt_tdhr">
                                    ACTION
                                </td>
                            </tr>
                        </tbody>
                    </table>


                    <b-card-group column v-for="item,idx in items" v-bind:data="item" v-bind:key="idx" style="margin-top: 10px; border: 1px solid lightgray;" class="text-monospace">
                        <b-card style="max-width: 200px;">
                            <b-card-text>
                                <h6><b>{{ idx + 1}}. {{ (item.invoice_id) }}</b></h6>
                            </b-card-text>

                            <b-card-text style="font-size: 11px; margin:0px; margin-top: 2px;"> 
                                <b>{{packet.locationsdict[item.location_id]}}</b>
                            </b-card-text>

                            <b-card-text style="font-size: 11px; margin:0px; margin-top: 2px">
                                Created:
                                {{ item.created_date }}
                            </b-card-text>

                            <b-card-text style="font-size: 11px; margin:0px; margin-top: 2px;">
                                Delivery:
                                <flat-pickr v-model="item.request_date" :config="{ dateFormat: 'm-d-Y' }" style="max-width: 80px; text-align: center; border: 1px solid slategray;"></flat-pickr>
                            </b-card-text>

                            <b-card-text style="font-size: 11px; margin:0px; margin-top: 2px;">
                                <div :style="{'color': global_vars.TRANSFER_STATUSES_COLORS_DICT[item.status], 'font-weight': 'bold'}">{{ global_vars.TRANSFER_STATUSES_DICT[item.status]}}</div>
                            </b-card-text>

                           

                            <b-card-text style="font-size: 11px; margin:0px; margin-top: 2px;">
                                <b-button size="sm" variant="outline-dark" @click="update_hybrid(item)">UPDATE</b-button>
                            </b-card-text>

                        </b-card>

                        <b-card style="max-width: 200px;">
                             <b-card-text style="font-size: 11px; margin:0px; margin-top: 2px;" v-if="item.pull_date">
                                Pull Date:
                                <flat-pickr v-model="item.pull_date" :config="{ dateFormat: 'm-d-Y' }" style="max-width: 80px; text-align: center; border: 1px solid slategray;"></flat-pickr>
                            </b-card-text>

                            <b-card-text style="font-size: 11px; margin:0px; margin-top: 2px;" v-if="item.stage_for">
                                Stage for:
                                <input style="width: 80px;" v-model="item.stage_for"></input>
                            </b-card-text>

                            <b-card-text style="font-size: 11px; margin:0px; margin-top: 2px;" v-if="item.truck">
                                Truck # :
                                <input style="width: 80px;" v-model="item.truck"></input>
                            </b-card-text>
                        </b-card>

                        <b-card>
                            <table style="width: 100%;">
                                <thead>
                                    <tr style="background: white; color: black;">
                                        <td class="ipt_tdhr tdfonter">
                                            PRD
                                        </td>
                                        <td class="ipt_tdhr tdfonter">
                                            QTY
                                        </td>
                                        <td class="ipt_tdhr tdfonter">
                                            FULFILL FRM
                                        </td>
                                        <td class="ipt_tdhr tdfonter">
                                            STATUS
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="element, eidx in item.items">
                                        <td class="ipt_tdhr tdfonter" style="font-weight: normal;" v-bind:key="eidx">
                                            {{ element.product_sku }}
                                        </td>
                                        <td class="ipt_tdhr tdfonter" style="font-weight: normal;">
                                            {{ element.quantity }}
                                        </td>
                                        <td class="ipt_tdhr tdfonter" style="font-weight: normal;">
                                            
                                            <b-form-select 
                                                size="sm" 
                                                style="max-width: 200px; font-size: 9px;"
                                                v-model="element.locsub"
                                                :disabled="packet.userDetails.userrole != 'admin' || item.status >= global_vars.TRANSFER_STATUSES_REVERSE_DICT['PULLED']"
                                            >
                                                <b-form-select-option v-for="locsub,lidx in packet.locsubs" :value="locsub.value" v-bind:key="lidx">
                                                    
                                                    {{ all_loc_inventory_dict[
                                                        JSON.stringify(element.product_id)
                                                        +
                                                        element.product_sku
                                                        +
                                                        JSON.stringify(locsub.location_id)
                                                        +
                                                        JSON.stringify(locsub.sublocation_id)
                                                    ]}} 

                                                    - 

                                                    {{ locsub.location }} | {{ locsub.sublocation }} 
                                                </b-form-select-option>
                                            </b-form-select>                        
                                        </td>
                                        <td class="ipt_tdhr tdfonter" style="font-weight: normal;">
                                            {{ element.state }}
                                            <!-- <span v-if="element.pulled_status">
                                                <span v-if="element.pulled_status == 'pulled'">
                                                    <b-card-text style="font-size: 9px; background: #dcf7a6; margin-top: 5px;">
                                                        
                                                        <div>Pulled ({{element.pulled_by}})</div>
                                                        <div>({{element.pulled_ts}})</div>
                                                    </b-card-text>
                                                </span>
                                                <span v-else-if="element.pulled_status == 'cannot_be_pulled'">
                                                    <b-card-text style="font-size: 9px; background: salmon; margin-top: 5px;">
                                                        
                                                        <div>Can't Pull ({{element.pulled_by}})</div>
                                                        <div>({{element.pulled_ts}})</div>
                                                    </b-card-text>
                                                </span>
                                            </span>

                                            <span v-if="element.picked_status">
                                                <span v-if="element.picked_status == 'picked'">
                                                    <b-card-text style="font-size: 9px; background: lightblue; margin-top: 5px;">
                                                        <div>Picked ({{element.picked_by}})</div>
                                                        <div>({{element.picked_ts}})</div>
                                                    </b-card-text>
                                                </span>
                                                <span v-else-if="element.picked_status == 'cannot_be_picked'">
                                                    <b-card-text style="font-size: 9px; background: salmon; margin-top: 5px;">
                                                        
                                                        <div>Can't Pick ({{element.picked_by}})</div>
                                                        <div>({{element.picked_ts}})</div>
                                                    </b-card-text>
                                                </span>
                                            </span> -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <b-card-group column>
                                <b-card no-body style="border: 0px; margin-top: 5px; padding: 10px;">
                                    <div v-for="comment, cidx in item.comments" style="margin: 2px; background: #efefef; padding: 5px; font-size: 11px;" v-bind:key="cidx">

                                        <div v-if="comment.is_new">
                                            <input style="padding: 5px; border: 1px solid #efefef; width: 100%;" v-model="comment.txt"></input>
                                        </div>

                                        <div v-else>
                                            {{comment.ts}} : {{ comment.txt }} (<i>{{comment.username}}</i>)
                                        </div>
                                    </div>

                                    <b-card-text style="margin: 5px;">
                                        <b-button size="sm" variant="outline-dark" @click="add_new_comment(item)" style="font-size: 10px;">Add Comment</b-button>
                                    </b-card-text>
                                </b-card>

                                <b-card no-body style="border: 0px; margin-top: 5px; padding: 10px;">
                                    <div style="margin-top: 10px; text-align: center;">
                                        <b-card-text v-if="item.status == global_vars.TRANSFER_STATUSES_REVERSE_DICT['PENDING']">
                                            <b-button size="sm" variant="success" @click="mark_approve(item)">APPROVE</b-button>
                                            
                                            <!-- <b-button size="sm" variant="danger" @click="mark_reject(item)">REJECT</b-button>
                                             -->
                                        </b-card-text>

                                        <!-- <b-card-text v-else-if="item.status == global_vars.TRANSFER_STATUSES_REVERSE_DICT['APPROVED']">
                                            
                                            <b-card style="max-width: 200px; margin-left: auto;">
                                                <div>
                                                    <div style="font-size: 12px;">Stage For</div>
                                                    <div style="">
                                                        <b-input size="sm" style="font-weight: bold;" v-model="item.stage_for"></b-input>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div style="font-size: 12px;">Pull Date</div>
                                                    <div style="">
                                                        <flat-pickr v-model="item.pull_date" :config="{ dateFormat: 'm-d-Y' }" style="max-width: 150px; text-align: center; border: 1px solid slategray;"></flat-pickr>
                                                    </div>
                                                </div>

                                                <div style="margin-top: 5px;">
                                                    <b-button size="sm" variant="outline-success" @click="add_to_be_pulled(item)">ADD TO BE PULLED</b-button>
                                                </div>
                                            </b-card>
                                        </b-card-text> -->
                                    </div>

                                    <div style="margin-top: 10px; text-align: center;" v-if="item.status == global_vars.TRANSFER_STATUSES_REVERSE_DICT['READY TO SHIP']">
                                            <b-button size="sm" variant="primary" @click="mark_shipped(item)">Mark As Shipped</b-button>
                                            <b-card no-body style="font-size: 9px; padding: 3px; margin-top: 5px;">Marking an item as shipped will take all the items in this order out of source inventory</b-card>
                                    </div>

                                    <div style="margin-top: 10px; text-align: center;" v-if="item.status == global_vars.TRANSFER_STATUSES_REVERSE_DICT['SHIPPED']">
                                            <b-button size="sm" variant="secondary" disabled>SHIPPED</b-button>
                                    
                                    </div>
                                </b-card>
                            </b-card-group>
                        </b-card>
                    </b-card-group>
                </div>
                <div v-else>
                    <b-alert show variant="warning">No Data To Show</b-alert>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import global_vars from '@/utilities/global_vars'
    import Requestor from '@/utilities/Requestor'
    export default {
        name: "AdminToolsAllOrders",
        components: {flatPickr},
        data: function(){
            return {
                items: [],
                packet: {},
                items_being_loaded: false,
                date_counts: [],
                global_vars: global_vars,
                active_date: null,
                all_loc_inventory_dict: {},
                date_type_options: [
                    {value: "delivery_date", text: "Delivery Dates"},
                    {value: "order_date", text: "Order/Sale Dates"}
                ],
                date_type: "order_date"
            }
        },
        methods: {
            update_hybrid: function(item){
                let path = "/api/transfers/update_hybrid/"
                let that = this;
                let data = item;

                if (data.status >= this.global_vars.TRANSFER_STATUSES_REVERSE_DICT["ADDED TO PULLIST"]){
                    if (!data.stage_for){
                        this.$vex.dialog.alert({
                            message: "Please specify a staging location for the item"
                        });
                        return
                    }

                    if (!data.pull_date){
                        this.$vex.dialog.alert({
                            message: "Please specify a valid pull date."
                        });
                        return
                    }
                }
                
                if (!data.request_date){
                    this.$vex.dialog.alert({
                        message: "Please specify a valid delivery date."
                    });
                    return
                }

                item.comments = item.comments.map(function(d){
                    delete d.is_new
                    return d
                })

                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Updated.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                }
                let f = function(error){
                    that.$bvToast.toast(
                        "Error updating transfer. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                
                Requestor.postAsyncP(path, data, this, s, f);
            },
            add_to_be_pulled: function(item){
                let path = "/api/transfers/update/"
                let that = this;
                let data = item;

                if (!data.stage_for){
                    this.$vex.dialog.alert({
                        message: "Please specify a staging location for the item"
                    });
                    return
                }
                if (!data.pull_date){
                    this.$vex.dialog.alert({
                        message: "Please specify a valid pull date."
                    });
                    return
                }

                data.status = this.global_vars.TRANSFER_STATUSES_REVERSE_DICT["ADDED TO PULLIST"];

                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Updated.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        if (data.stage_for != null){
                            item.status = that.global_vars.TRANSFER_STATUSES_REVERSE_DICT["ADDED TO PULLIST"];
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                }
                let f = function(error){
                    that.$bvToast.toast(
                        "Error updating transfer. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                
                Requestor.postAsyncP(path, data, this, s, f);
            },
            mark_approve: function(item){
                
                let locsubs = item.items.map(function(d){return d.locsub})
                if (locsubs.indexOf(null) >= 0){
                    this.$vex.dialog.alert({
                        message: "Cannot approve an order without assigning all fulfilling locations."
                    });
                    return
                }

                item.status = this.global_vars.TRANSFER_STATUSES_REVERSE_DICT["APPROVED"];
                item.items = item.items.map(function(d){
                    let locsub = d.locsub;
                    if (locsub){
                        let splitted = locsub.split("|");
                        d.source_location_id = +splitted[0];
                        d.source_sublocation_id = +splitted[1];
                    }
                    
                    return d;
                });
                item.stage_for = null;

                let path = "/api/transfers/update/"
                let that = this;
                let data = item;

                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Updated.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        item.status = that.global_vars.TRANSFER_STATUSES_REVERSE_DICT["APPROVED"];
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        item.status = that.global_vars.TRANSFER_STATUSES_REVERSE_DICT["PENDING"];
                    }
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating transfer. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.status = that.global_vars.TRANSFER_STATUSES_REVERSE_DICT["PENDING"];
                }
                
                Requestor.postAsyncP(path, data, this, s, f);
            },
            mark_shipped: function(item){
                item.status = this.global_vars.TRANSFER_STATUSES_REVERSE_DICT["SHIPPED"];

                let path = "/api/transfers/mark_shipped/"
                let that = this;
                let data = item;

                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Updated.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        item.status = that.global_vars.TRANSFER_STATUSES_REVERSE_DICT["SHIPPED"];
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        item.status = that.global_vars.TRANSFER_STATUSES_REVERSE_DICT["READY TO SHIP"];
                    }
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating transfer. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.status = that.global_vars.TRANSFER_STATUSES_REVERSE_DICT["READY TO SHIP"];
                }
                
                Requestor.postAsyncP(path, data, this, s, f);
            },
            fetch_data: function(date_count){
                this.active_date = date_count.dt;
                let path = "/api/transfers/get_all_transfers_for_date/"
                let data = {dt: date_count.dt, date_type: this.date_type}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                        that.items = that.items.map(function(d){
                            d.items = d.items.map(function(e){
                                if (e.source_location_id != null){
                                    e.locsub = e.source_location_id +'|'+e.source_sublocation_id
                                }
                                else {
                                    e.locsub = null;
                                }
                                
                                return e
                            })
                            return d
                        })
                        console.log(that.items)
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading data. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                this.items = [];
                Requestor.getAsyncP(path, data, this, s, f);

            },
            get_variant: function(date_count){
                if (this.active_date == date_count.request_date){
                    return "warning"
                }
                else {
                    return "outline-warning"
                }
            },
            fetch_counts_by_dates: function(date_type){
                if (!date_type){
                    date_type = this.date_type;
                }
                let path = "/api/transfers/get_transfers_counts_by_date/";
                let data = {"date_type": date_type}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.date_counts = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }
                
                let f = function(error){
                    console.log(error, 'ues')
                    that.$bvToast.toast(
                        "Error loading counts.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                this.items = [];
                this.active_date = null;
                Requestor.getAsyncP(path, data, this, s, f);

            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/inventory/get_all_loc_inventory_dict/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.all_loc_inventory_dict = response.data.result;
                                that.fetch_counts_by_dates(that.date_type)
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading inventory.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ];

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            add_new_comment: function(item){
                item.comments.push({
                    ts: moment().format('MM-DD-YYYY HH:mm'),
                    txt: null,
                    username: this.packet.userDetails.username,
                    is_new: true
                });
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.packet.global_vars = global_vars;
            this.fetch_prereqs()
        }
    }
</script>

<style scoped>
    h5, h4, h3 {
        margin: 0px;
    }

    .tdfonter {
        font-size: 10px;
    }

    td {
        font-weight: normal;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsAllOrders.vue